import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import { STATUS_CAMPAIGN_LOG_OPTIONS, TRANSACTIONS_LOG_TYPE_OBJECT_COLOR, TRANSACTIONS_LOG_TYPE_OBJECT_LABEL, TRANSACTIONS_LOG_TYPE_OPTIONS } from "helpers/constans";
import { formatTimeToAgo } from "helpers/format";
import moment from "moment";
import { RenderContentDateRange } from "pages/Trade/components/RenderContentDateRange";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import {
    NumberParam,
    StringParam,
    useQueryParams,
    withDefault,
} from "use-query-params";
import { getCampaignLogs as onGetCampaignLogs, getOptionPools as onGetOptionPools } from "../../store/thunks";

const TYPE_SELECT_DEFAULT: string = "id";

export default function EventLog() {
    const { t, i18n } = useTranslation();

    const isFirstLoadingPageRef = useRef<any>(true);

    const [typeShowPriceColumn, setTypeShowPriceColumn] = useState<'USD' | 'NATIVE'>('USD');

    const TRANSACTIONS_LOG_TYPE_OPTIONS_LANG = TRANSACTIONS_LOG_TYPE_OPTIONS.map((item) => ({ label: t(item.label), value: item.value }));

    const STATUS_CAMPAIGN_LOG_OPTIONS_LANG = STATUS_CAMPAIGN_LOG_OPTIONS.map((item) => ({ label: t(item.label), value: item.value }));

    const defaultStart = null; // moment(new Date(), "Y-MM-DD HH:mm").subtract(24, "hours").toDate();
    const defaultEnd = null; // moment(new Date(), "Y-MM-DD HH:mm").toDate();

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        limit: withDefault(NumberParam, 100),
        page: withDefault(NumberParam, 1),
        // sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        pair: withDefault(StringParam, ""),
        type: withDefault(StringParam, TRANSACTIONS_LOG_TYPE_OPTIONS_LANG[0]?.value),
        fromDate: withDefault(StringParam, `${defaultStart ? moment(defaultStart).format('Y-MM-DD HH:mm') : ''}`),
        toDate: withDefault(StringParam, `${defaultEnd ? moment(defaultEnd).format('Y-MM-DD HH:mm') : ''}`),
        amountMin: withDefault(StringParam, ""),
        amountMax: withDefault(StringParam, ""),
        totalMin: withDefault(StringParam, ""),
        totalMax: withDefault(StringParam, ""),
        walletAddress: withDefault(StringParam, ""),
        id: withDefault(StringParam, ""),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => {
        return state.Pool;
    };

    const PoolProperties = createSelector(selectLayoutState, (state) => ({
        optionPools: state.optionPools || [],
        isOptionPoolSuccess: state.isOptionPoolSuccess,
        isOptionPoolLoading: state.isOptionPoolLoading,
        error: state.error,
    }));

    // Inside your component
    const { optionPools } = useSelector(PoolProperties);

    const [listPool, setListPool] = useState<any>([]);

    useEffect(() => {
        dispatch(onGetOptionPools({}));
    }, [dispatch]);

    const [objectPoolLogo, setObjectPoolLogo] = useState<any>({});

    const [makerFilter, setMakerFilter] = useState(query?.walletAddress || '');
    const [pairFilter, setPairFilter] = useState("");
    const [campaignIdFilter, setCampaignIdFilter] = useState(query?.id || '');
    const [poolSearch, setPoolSearch] = useState<any>(null);
    const [typeFilter, setTypeFilter] = useState<any>(TRANSACTIONS_LOG_TYPE_OPTIONS_LANG?.find((item: any) => item?.value === query?.type) || TRANSACTIONS_LOG_TYPE_OPTIONS_LANG[0]);

    const [amount, setAmount] = useState<any>({ min: "", max: "" });
    const [total, setTotal] = useState<any>({ min: "", max: "" });

    const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.fromDate ? moment(query?.fromDate || "", 'Y-MM-DD HH:mm').toDate() : null, query?.toDate ? moment(query?.toDate || "", 'Y-MM-DD HH:mm').toDate() : null])
    const [startDate, endDate] = dateRangeSearch;

    const [logList, setLogList] = useState<{ list: any[], total: number }>({ list: [], total: 0 });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleQueryData = async () => {
        try {
            setIsLoading((prev) => true);
            const res: any = await onGetCampaignLogs(query);
            setLogList((prev: any) => ({
                list: Number(query?.page) === 1 ? (res?.data?.rows || []) : (prev?.list || []).concat(res?.data?.rows || []),
                total: res?.data?.total_rows || 0
            }));
            setIsLoading((prev) => false);
        } catch (error: any) {
            setIsLoading((prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
        }
    };

    const handleLoadMore = () => {
        setQuery({
            ...query,
            page: query?.page + 1,
        });
    };

    useEffect(() => {
        handleQueryData();
    }, [JSON.stringify(query)]);


    const convertTimeToAgo = (time: any) => {
        const localTime: any = moment.unix(time).tz(moment.tz.guess());
        const date = new Date(localTime);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const minutes = Math.floor(diff / 1000 / 60);
        const hours = Math.floor(diff / 1000 / 60 / 60);
        const days = Math.floor(diff / 1000 / 60 / 60 / 24);

        if (days > 0) {
            return moment(date).tz(moment.tz.guess()).format("YYYY/MM/DD HH:mm");
        } else if (hours > 0) {
            return moment(date).tz(moment.tz.guess()).format("YYYY/MM/DD HH:mm");
        } else if (minutes > 0) {
            return `${minutes} ${t("minutes ago")}`;
        } else {
            return `${Math.floor(diff / 1000)}${t("s ago")}`;
        }
    };


    const searchData = () => {
        isFirstLoadingPageRef.current = false;
        setLogList((prev: any) => ({
            list: [],
            total: 0
        }));
        setQuery({
            ...query,
            type: typeFilter?.value,
            walletAddress: makerFilter,
            fromDate: startDate ? `${moment(startDate).format("Y-MM-DD HH:mm")}` : '',
            toDate: endDate ? `${moment(endDate).format("Y-MM-DD HH:mm")}` : '',
            amountMin: amount?.min,
            amountMax: amount?.max,
            totalMin: total?.min,
            totalMax: total?.max,
            pair: poolSearch?.value || pairFilter || '',
            id: campaignIdFilter,
            page: 1,
            time_request: + new Date()
        });
    };

    const resetData = () => {
        isFirstLoadingPageRef.current = false;
        const newQuery = {
            ...query,
            page: 1,
            type: TRANSACTIONS_LOG_TYPE_OPTIONS_LANG[0]?.value,
            fromDate: '', // `${moment().subtract(24, "hours").format("Y-MM-DD HH:mm")}`,
            toDate: '', // `${moment().format("Y-MM-DD HH:mm")}`,
            walletAddress: '',
            pair: '',
            amountMin: '',
            amountMax: '',
            totalMin: '',
            totalMax: '',
            id: '',
            time_request: + new Date()
        };
        setLogList((prev: any) => ({
            list: [],
            total: 0,
        }));
        setMakerFilter("");
        setPairFilter("");
        setCampaignIdFilter("");
        setPoolSearch(null);
        setTypeFilter(TRANSACTIONS_LOG_TYPE_OPTIONS_LANG[0]);
        setAmount({ min: '', max: '' });
        setTotal({ min: '', max: '' });
        setDateRangeSearch([null, null]); // moment(newQuery?.fromDate || "", 'Y-MM-DD HH:mm').toDate(), moment(newQuery?.toDate || "", 'Y-MM-DD HH:mm').toDate()
        setQuery(newQuery, "push");
    };

    // const columnNameAmountToken = useMemo(() => {
    //     const _symbol = listPool?.find((_pool: any) => _pool?.value === query?.pair);
    //     const name1 = _symbol?.tokenSymbol1 ? `${t('Amount')} ${_symbol?.tokenSymbol1}` : t('Token Amount');
    //     const name2 = _symbol?.tokenSymbol2 ? `${t('Amount')} ${_symbol?.tokenSymbol2}` : t('Token Amount');
    //     return [name1, name2];
    // }, [query?.pair, listPool, i18n?.language]);

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t("Date"),
                accessor: "timestamp",
                filterable: true,
                sortable: false,
                thWidth: 150,
                Cell: (cell: any) => {
                    const _date_time: string = formatTimeToAgo(cell?.value, t, true);
                    const _date_times: string[] = String(_date_time)?.split(' ');
                    return (<>
                        <div style={{ minWidth: "130px" }}>
                            <div className="text-muted">
                                {_date_times?.[1] || '-'}
                            </div>
                            <div>
                                {_date_times?.[0] || '-'}
                            </div>
                        </div>
                    </>
                    )
                },
            },
            {
                Header: t("Campaign ID"),
                accessor: "campaign",
                filterable: true,
                sortable: false,
                thWidth: 100,
                thClass: "text-start",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "80px" }} className="text-start">
                                {item?.campaign_id || '-'}
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Status"),
                accessor: "status",
                filterable: true,
                sortable: false,
                thWidth: 100,
                thClass: "text-center",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const COLOR: any = {
                        success: 'success',
                        error: 'danger',
                    };
                    return (
                        <>
                            <div style={{ minWidth: "60px" }} className="text-center">
                                <span className={`rounded-pill badge bg-${COLOR?.[item?.status] || 'secondary'}`}>{STATUS_CAMPAIGN_LOG_OPTIONS_LANG?.find((_i: any) => String(_i?.value) === String(item?.status))?.label}</span>
                            </div>
                        </>
                    );
                },
            },

            {
                Header: t("Event Type"),
                accessor: "type",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: "text-center",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const types = (item?.type || '')?.split('&');
                    return (
                        <div className="d-flex flex-wrap flex-column gap-2">
                            {types?.map((_type: any) => (<div key={_type} style={{ minWidth: "100px" }} className="row-transition-bg-colors font-semibold text-center">
                                <span className={`${TRANSACTIONS_LOG_TYPE_OBJECT_COLOR[`${_type}`] || '-'}`}>
                                    {t(TRANSACTIONS_LOG_TYPE_OBJECT_LABEL[`${_type}`] || '-')}
                                </span>
                            </div>
                            ))}
                        </div>
                    );
                },
            },
            {
                Header: t("Message"),
                accessor: "message",
                filterable: true,
                sortable: false,
                thWidth: 200,
                thClass: "text-start",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "120px" }} className="text-start">
                                {item?.message || '-'}
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Maker"),
                accessor: "wallet_address",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="text-end">
                                <CopyWrapper
                                    isShow={true}
                                    contentCopy={item?.wallet_address}
                                >
                                    <span>
                                        {item?.wallet_address?.slice(0, 8) +
                                            "..." +
                                            item?.wallet_address?.slice(-6)}
                                    </span>
                                </CopyWrapper>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("TXN"),
                accessor: "transaction_hash",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="text-end">
                                <Link to={`https://solscan.io/tx/${item?.transaction_hash}`} target="_blank" className="d-inline-block hover-underline">
                                    <CopyWrapper
                                        isShow={true}
                                        contentCopy={item?.transaction_hash}
                                    >
                                        {" "}
                                        <span>
                                            {item?.transaction_hash?.slice(0, 8) +
                                                "..." +
                                                item?.transaction_hash?.slice(-6)}
                                        </span>
                                    </CopyWrapper>
                                </Link>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Created at"),
                accessor: "CreatedAt",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || "").split("T");
                    return (
                        <div className="text-end" style={{ minWidth: "120px" }}>
                            <span>
                                <span>{arrDate?.[0] || "-"}</span> <br />{" "}
                                <span className="text-secondary">{String(arrDate?.[1] || "")?.split('.')[0] || '-'}</span>{" "}
                            </span>
                        </div>
                    );
                },
            },
        ],
        [i18n?.language, query, objectPoolLogo, typeShowPriceColumn]
    );


    useEffect(() => {
        const _obj = (optionPools || [])?.reduce((_ob: any, _p: any) => {
            return ({
                ..._ob,
                [`${_p?.pairAddress}`]: {
                    name: _p?.pairLabel || '',
                    symbol_token_1: _p?.tokens?.[0]?.tokenSymbol || '',
                    logo_token_1: _p?.tokens?.[0]?.tokenLogo || '',
                    decimal_token_1: _p?.tokens?.[0]?.tokenDecimals || '4',
                    symbol_token_2: _p?.tokens?.[1]?.tokenSymbol || '',
                    logo_token_2: _p?.tokens?.[1]?.tokenLogo || '',
                    decimal_token_2: _p?.tokens?.[1]?.tokenDecimals || '4',
                }
            });
        }, {});
        const list = (optionPools || [])?.map((item: any) => {
            return {
                value: item?.pairAddress,
                label: item?.pairLabel,
                logo1: item?.tokens?.[0]?.tokenLogo,
                logo2: item?.tokens?.[1]?.tokenLogo,
                tokenSymbol1: item?.tokens?.[0]?.tokenSymbol,
                tokenSymbol2: item?.tokens?.[1]?.tokenSymbol,
                pair: item?.pairLabel || '',
            };
        });


        setListPool(list);
        setObjectPoolLogo(() => _obj);
        if (query?.pair) {
            const pool_search = list?.find((_pool: any) => _pool?.value === query?.pair) || null;
            setPoolSearch(pool_search);
            setPairFilter(!!pool_search?.value ? '' : query?.pair);
        }
    }, [optionPools]);

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 });
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return { ..._prev, ...sortBy };
        });
    }, []);

    useEffect(() => {
        document.title = `${t("Home")} - ${t("Event Log")}`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("Event Log")} pageTitle={t("Home")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="customerList"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <CardHeader className="border-0">
                                    <Row className="g-4 align-items-center">
                                        <div className="col-5 con-sm-6">
                                            <div>
                                                <h5 className="card-title mb-0">
                                                    <span className="me-2">{t("Total")}:</span>
                                                    {(isLoading && (Number(query?.page) === 1)) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={logList?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </h5>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                    <Row>
                                        <Col sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-md-2"
                                        >
                                            <LabelWrapper label={t('Label_Pool')} isShow={true}>
                                                <DropdownPoolOption
                                                    isMultiLang
                                                    name="pool"
                                                    dataList={listPool}
                                                    initialValue={poolSearch || null}
                                                    onChangeSelect={(event: any) => { setPoolSearch((_prev: any) => event); }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={true}
                                                    // className="bg-[#fff]"
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('All'),
                                                        value: ''
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-md-2 order-0 order-sm-1 order-md-0"
                                        >
                                            <LabelWrapper label={t("Label_Pool_Number")} isShow={true}>
                                                <Input
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder={`${t("Label_Pool_Number")}...`}
                                                    value={pairFilter}
                                                    onChange={(e) => setPairFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            searchData();
                                                        }
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-md-2 order-0 order-sm-1 order-md-0"
                                        >
                                            <LabelWrapper label={t("Campaign ID")} isShow={true}>
                                                <Input
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder={`${t("Campaign ID")}...`}
                                                    value={campaignIdFilter}
                                                    onChange={(e) => setCampaignIdFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            searchData();
                                                        }
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>


                                        {/* <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="items-center mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("Label_Total")} isShow={true}>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type="number"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Min")}`}
                                                        value={total?.min}
                                                        onChange={(e) =>
                                                            setTotal((_prev: any) => ({ ..._prev, min: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                    <p className="py-2">→</p>
                                                    <Input
                                                        type="number"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Max")}`}
                                                        value={total?.max}
                                                        onChange={(e) =>
                                                            setTotal((_prev: any) => ({ ..._prev, max: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </LabelWrapper>
                                        </Col> */}
                                        {/* <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("Label_Amount")} isShow={true}>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Min")}`}
                                                        value={amount?.min}
                                                        onChange={(e) =>
                                                            setAmount((_prev: any) => ({ ..._prev, min: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                    <p className="py-2">→</p>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Max")}`}
                                                        value={amount?.max}
                                                        onChange={(e) =>
                                                            setAmount((_prev: any) => ({ ..._prev, max: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </LabelWrapper>
                                        </Col> */}

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("DateTime")} isShow={true}>
                                                <RenderContentDateRange
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    setDateRangeSearch={setDateRangeSearch}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 order-0"
                                        >
                                            <LabelWrapper label={t("Event Type")}>
                                                <DropdownOption
                                                    isMultiLang
                                                    name="type"
                                                    dataList={TRANSACTIONS_LOG_TYPE_OPTIONS_LANG}
                                                    initialValue={typeFilter || TRANSACTIONS_LOG_TYPE_OPTIONS_LANG?.[0]}
                                                    onChangeSelect={(event: any) => {
                                                        setTypeFilter((_prev: any) => event);
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    labelTop="Event Type"
                                                />
                                            </LabelWrapper>
                                        </Col>


                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={6}
                                            xxl={6}
                                            className="mt-3 order-0 order-sm-1 order-md-0"
                                        >
                                            <LabelWrapper label={t("Maker")} isShow={true}>
                                                <Input
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder={`${t("Maker")}...`}
                                                    value={makerFilter}
                                                    onChange={(e) => setMakerFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            searchData();
                                                        }
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={12}
                                            xl={3}
                                            xxl={3}
                                            className="hstack gap-1 order-0 order-sm-3 order-md-0 justify-content-center justify-content-sm-end mt-3 "
                                        >
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2 bg-[#009ef7] !hover:bg-[#0086d2]"
                                                    onClick={searchData}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                    {t("Button Search")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14 bg-[#878a99] !hover:bg-[#737582]"
                                                    onClick={() => {
                                                        // emitSendMessage({ pool: 'aaaaaaaaaaaaaaaaa' });
                                                        resetData()
                                                    }}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t("Button Reset")}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row className="g-4 align-items-center mt-0">
                                        <Col sm={6} md={8} xl={9} xxl={10} className="hstack gap-1 justify-content-center justify-content-sm-start mt-3">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2  bg-[#009ef7] hover:bg-[#0086d2]"
                                                    onClick={searchData}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                    {t('Button Search')}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14  bg-[#878a99] hover:bg-[#737582]"
                                                    onClick={resetData}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t('Button Reset')}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row> */}
                                </div>
                                <CardBody className="pt-0 px-0">
                                    <InfiniteScroll
                                        dataLength={logList?.list?.length || 0}
                                        next={handleLoadMore}
                                        scrollableTarget='scrollableDiv'
                                        hasMore={logList && logList?.list?.length < logList?.total ? true : false}
                                        loader={''} // loader={<LoadingListNotify />}
                                        scrollThreshold={'50%'}
                                    >
                                        <div className="mx-3 my-4 mt-3">
                                            <TableContainer
                                                className="custom-header-css"
                                                divClass="table-responsive table-card"
                                                tableClass="align-middle sticky-table-wallet"
                                                theadClass="table-light"
                                                columns={columns}
                                                data={logList?.list?.length ? logList?.list : []}
                                                customPageSize={query.limit}
                                                customPageIndex={query.page - 1}
                                                totalRecords={logList?.total}
                                                // customPageCount={1}
                                                customPageCount={1}
                                                handleChangePage={handleChangePage}
                                                manualSorting={true}
                                                sorting={{
                                                    sort_by: query.sort_by,
                                                    order_by: query.order_by,
                                                }}
                                                handleChangeSorting={handleChangeSorting}
                                                isLoading={isLoading}
                                                isShowPagination={false}
                                                isShowLoadingBottom={query.page > 1}
                                                isScrollToTop={false}
                                            />
                                        </div>
                                    </InfiniteScroll>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ToastContainer autoClose={2000} limit={1} />
            </div>
        </React.Fragment>
    );
}
